// VIBRANIAM-SPACE v2 - ErrorBoundary.jsx
// Safety net: an uncaught render-phase error anywhere below this stops
// propagating past it instead of unmounting the whole app. The graph itself
// lives in App (useModuleGraph), one level above every boundary in this file,
// so "riprova" always remounts a clean child without losing the patch.

import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(`[ErrorBoundary${this.props.label ? `:${this.props.label}` : ''}]`, error, info?.componentStack);
    this.props.onError?.(error, info);
  }

  reset = () => {
    this.setState({ error: null });
    this.props.onReset?.();
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-3 bg-ink-900 p-6 text-center">
        <div className="text-[11px] font-semibold uppercase tracking-wider text-red-300">
          {this.props.label || 'Componente'} — errore imprevisto
        </div>
        <div className="max-w-md whitespace-pre-wrap break-words rounded border border-red-500/30 bg-red-950/30 p-2 font-mono text-[10px] leading-snug text-red-200/80">
          {String(this.state.error?.message || this.state.error)}
        </div>
        <p className="max-w-sm text-[10px] text-slate-500">
          Il resto dell&apos;app resta utilizzabile. La patch non è andata persa: riprova per
          ricaricare solo questo pannello.
        </p>
        <button
          type="button"
          onClick={this.reset}
          className="rounded bg-vibe-cyan px-3 py-1.5 text-[11px] font-semibold text-ink-900 transition hover:brightness-110"
        >
          Riprova
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
